import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import './AlgorithmTrain.css';

const AlgorithmTrain = () => {
    const navigate = useNavigate();
    const [suggestions, setSuggestions] = useState({
        strength: [],
        shredded: [],
        loseWeight: []
    });
    const [loading, setLoading] = useState(true);
    const [userStats, setUserStats] = useState({
        totalWorkouts: 0,
        muscleGroupBalance: {},
        recentWorkouts: []
    });

    // All available trainers from different categories - EXPANDED WITH NEW TRAINERS!
    const allTrainers = {
        // Original Bodyweight Trainers
        bodyweight: [
            { id: 'sarah-chen', name: 'Sarah Chen', category: 'bodyweight', description: 'Body Weight Training Specialist', difficulty: 'Beginner', image: '/assets/images/v22.jpg' },
            { id: 'marcus-steel', name: 'Marcus Steel', category: 'bodyweight', description: 'Functional Movement Expert', difficulty: 'Intermediate', image: '/assets/images/v82.jpg' },
            { id: 'phoenix-wright', name: 'Phoenix Wright', category: 'bodyweight', description: 'Time-Focused Specialist', difficulty: 'Beginner', image: '/assets/images/v83.jpg' },
            { id: 'alex-steele', name: 'Alex Steele', category: 'bodyweight', description: 'Athletic Performance', difficulty: 'Intermediate', image: '/assets/images/v88.jpg' },
            { id: 'jack-reynolds', name: 'Jack Reynolds', category: 'bodyweight', description: 'Mobility & Functional Movement', difficulty: 'Beginner', image: '/assets/images/v75.jpg' },
            { id: 'mike-johnson', name: 'Mike Johnson', category: 'bodyweight', description: 'Strength & Power', difficulty: 'Advanced', image: '/assets/images/v35.jpg' }
        ],
        // Original Advanced Bodyweight Trainers
        advanced: [
            { id: 'marcus-blackwood', name: 'Marcus Blackwood', category: 'advanced-bodyweight', description: 'Calisthenics & Gymnastics Master', difficulty: 'Elite', image: '/assets/images/v28.jpg' },
            { id: 'dante-rivera', name: 'Dante Rivera', category: 'advanced-bodyweight', description: 'Advanced Skills Specialist', difficulty: 'Elite', image: '/assets/images/v46.jpg' },
            { id: 'ethan-gold-harris', name: 'Ethan "Gold" Harris', category: 'advanced-bodyweight', description: 'Bodybuilding & Power', difficulty: 'Elite', image: '/assets/images/v62.jpg' },
            { id: 'victor-stone', name: 'Victor Stone', category: 'advanced-bodyweight', description: 'Tactical Strength & Combat', difficulty: 'Elite', image: '/assets/images/v78.jpg' },
            { id: 'logan-reeves', name: 'Logan Reeves', category: 'advanced-bodyweight', description: 'Movement Optimization', difficulty: 'Elite', image: '/assets/images/v80.jpg' },
            { id: 'derek-cruz', name: 'Derek "Iron" Cruz', category: 'advanced-bodyweight', description: 'Raw Functional Strength', difficulty: 'Elite', image: '/assets/images/v86.jpg' }        ],
        // Original Strength Trainers
        strength: [
            { id: 'axel-ironside', name: 'Axel Ironside', category: 'strength', description: 'Powerlifting & Maximum Strength', difficulty: 'Elite', image: '/assets/images/v69.jpg' },
            { id: 'magnus-steele', name: 'Magnus Steele', category: 'strength', description: 'Olympic Weightlifting', difficulty: 'Elite', image: '/assets/images/v70.jpg' },
            { id: 'brock-hammer', name: 'Brock "The Beast" Hammer', category: 'strength', description: 'Strongman & Functional', difficulty: 'Elite', image: '/assets/images/v72.jpg' },
            { id: 'kane-titanium', name: 'Kane Titanium', category: 'strength', description: 'Explosive Power & Athletic', difficulty: 'Advanced', image: '/assets/images/v76.jpg' },
            { id: 'rex-savage', name: 'Rex Savage', category: 'strength', description: 'Primal Strength & Savage Intensity', difficulty: 'Elite', image: '/assets/images/v81.jpg' },
            { id: 'dominic-crusher-stone', name: 'Dominic "Crusher" Stone', category: 'strength', description: 'Athletic Power & Sports', difficulty: 'Advanced', image: '/assets/images/v85.jpg' }
        ],
        // Original Everything Trainers
        everything: [
            { id: 'zephyr-blackstone', name: 'Zephyr Blackstone', category: 'everything', description: 'Universal Movement Master', difficulty: 'Elite', image: '/assets/images/v64.jpg' },
            { id: 'atlas-kaine', name: 'Atlas Kaine', category: 'everything', description: 'Comprehensive Training', difficulty: 'Elite', image: '/assets/images/v68.jpg' },
            { id: 'orion-phoenix', name: 'Orion Phoenix', category: 'everything', description: 'Total Body Transformation', difficulty: 'Advanced', image: '/assets/images/v71.jpg' },
            { id: 'vortex-shadowstone', name: 'Vortex Shadowstone', category: 'everything', description: 'Dimensional Movement', difficulty: 'Elite', image: '/assets/images/v73.jpg' },
            { id: 'talon-wolfe', name: 'Talon Wolfe', category: 'everything', description: 'Primal Conditioning', difficulty: 'Advanced', image: '/assets/images/v74.jpg' },
            { id: 'nova-steelheart', name: 'Nova Steelheart', category: 'everything', description: 'Cosmic Power Integration', difficulty: 'Elite', image: '/assets/images/v84.jpg' }
        ],
// NEW! History Trainers Group 1 (Ancient Conquerors)
        historyOne: [
            { id: 'alexander-the-great', name: 'Alexander the Great', category: 'history', description: 'Phalanx Formation & World Conquest', difficulty: 'Elite', image: '/assets/images/alexander-the-great.jpg' },
            { id: 'julius-caesar', name: 'Julius Caesar', category: 'history', description: 'Roman Legion & Political Domination', difficulty: 'Elite', image: '/assets/images/julius-caesar.jpg' },
            { id: 'hannibal-barca', name: 'Hannibal Barca', category: 'history', description: 'Tactical Genius & Mountain Warfare', difficulty: 'Elite', image: '/assets/images/hannibal-barca.jpg' },
            { id: 'attila-the-hun', name: 'Attila the Hun', category: 'history', description: 'Nomadic Warfare & Continental Terror', difficulty: 'Elite', image: '/assets/images/attila-the-hun.jpg' },
            { id: 'napoleon-bonaparte', name: 'Napoleon Bonaparte', category: 'history', description: 'Artillery Mastery & Imperial Conquest', difficulty: 'Elite', image: '/assets/images/napoleon-bonaparte.jpg' },
            { id: 'cleopatra-vii', name: 'Cleopatra VII', category: 'history', description: 'Intellectual Seduction & Divine Authority', difficulty: 'Advanced', image: '/assets/images/cleopatra-vii.jpg' }
        ],
        // NEW! History Trainers Group 2 (Renaissance Masters)
        historyTwo: [
            { id: 'michelangelo', name: 'Michelangelo', category: 'history', description: 'Sculptural Power & Ceiling Endurance', difficulty: 'Elite', image: '/assets/images/michelangelo.jpg' },
            { id: 'galileo-galilei', name: 'Galileo Galilei', category: 'history', description: 'Telescopic Precision & Scientific Method', difficulty: 'Advanced', image: '/assets/images/galileo-galilei.jpg' },
            { id: 'isaac-newton', name: 'Isaac Newton', category: 'history', description: 'Mathematical Physics & Universal Law', difficulty: 'Elite', image: '/assets/images/isaac-newton.jpg' },
            { id: 'albert-einstein', name: 'Albert Einstein', category: 'history', description: 'Relativity Theory & Thought Experiment', difficulty: 'Elite', image: '/assets/images/albert-einstein.jpg' },
            { id: 'nikola-tesla', name: 'Nikola Tesla', category: 'history', description: 'Electrical Innovation & Wireless Power', difficulty: 'Elite', image: '/assets/images/nikola-tesla.jpg' },
            { id: 'pablo-picasso', name: 'Pablo Picasso', category: 'history', description: 'Cubist Revolution & Multi-Perspective', difficulty: 'Advanced', image: '/assets/images/pablo-picasso.jpg' }
        ],
        // NEW! History Trainers Group 3 (Revolutionary Spirits)
        historyThree: [
            { id: 'spartacus', name: 'Spartacus', category: 'history', description: 'Gladiator Combat & Chain Breaking Strength', difficulty: 'Elite', image: '/assets/images/spartacus.jpg' },
            { id: 'boudica', name: 'Boudica', category: 'history', description: 'Celtic Warfare & Vengeance Conditioning', difficulty: 'Elite', image: '/assets/images/boudica.jpg' },
            { id: 'king-leonidas', name: 'King Leonidas', category: 'history', description: 'Spartan Elite & Last Stand Defense', difficulty: 'Elite', image: '/assets/images/king-leonidas.jpg' },
            { id: 'theodore-roosevelt', name: 'Theodore Roosevelt', category: 'history', description: 'Strenuous Life & Presidential Vigor', difficulty: 'Elite', image: '/assets/images/theodore-roosevelt.jpg' },
            { id: 'che-guevara', name: 'Che Guevara', category: 'history', description: 'Guerrilla Revolution & Socialist Consciousness', difficulty: 'Elite', image: '/assets/images/che-guevara.jpg' },
            { id: 'rasputin', name: 'Rasputin', category: 'history', description: 'Mystical Influence & Supernatural Endurance', difficulty: 'Elite', image: '/assets/images/rasputin.jpg' }
        ],
        // NEW! History Trainers Group 4 (Explorers & Adventurers)
        historyFour: [
            { id: 'marco-polo', name: 'Marco Polo', category: 'history', description: 'Silk Road Endurance & Cultural Bridge Building', difficulty: 'Elite', image: '/assets/images/marco-polo.jpg' },
            { id: 'christopher-columbus', name: 'Christopher Columbus', category: 'history', description: 'Ocean Navigation & New World Discovery', difficulty: 'Elite', image: '/assets/images/christopher-columbus.jpg' },
            { id: 'lewis-clark', name: 'Lewis & Clark', category: 'history', description: 'Continental Expedition & Wilderness Mapping', difficulty: 'Elite', image: '/assets/images/lewis-clark.jpg' },
            { id: 'ernest-shackleton', name: 'Ernest Shackleton', category: 'history', description: 'Antarctic Survival & Crisis Leadership', difficulty: 'Elite', image: '/assets/images/ernest-shackleton.jpg' },
            { id: 'amelia-earhart', name: 'Amelia Earhart', category: 'history', description: 'Aviation Pioneer & Gender Barrier Breaking', difficulty: 'Advanced', image: '/assets/images/amelia-earhart.jpg' },
            { id: 'wild-bill-hickok', name: 'Wild Bill Hickok', category: 'history', description: 'Frontier Justice & Lightning Reflexes', difficulty: 'Elite', image: '/assets/images/wild-bill-hickok.jpg' }
        ],
        // NEW! History Trainers Group 5 (Literary Giants & Cultural Legends)
        historyFive: [
            { id: 'edgar-allan-poe', name: 'Edgar Allan Poe', category: 'history', description: 'Gothic Literature & Dark Beauty Training', difficulty: 'Elite', image: '/assets/images/edgar-allan-poe.jpg' },
            { id: 'oscar-wilde', name: 'Oscar Wilde', category: 'history', description: 'Aesthetic Philosophy & Witty Elegance Training', difficulty: 'Elite', image: '/assets/images/oscar-wilde.jpg' },
            { id: 'wolfgang-amadeus-mozart', name: 'Wolfgang Amadeus Mozart', category: 'history', description: 'Musical Prodigy & Divine Composition Training', difficulty: 'Elite', image: '/assets/images/wolfgang-amadeus-mozart.jpg' },
            { id: 'vincent-van-gogh', name: 'Vincent van Gogh', category: 'history', description: 'Cosmic Vision & Passionate Artistry Training', difficulty: 'Elite', image: '/assets/images/vincent-van-gogh.jpg' },
            { id: 'blackbeard', name: 'Blackbeard', category: 'history', description: 'Pirate Terror & Maritime Domination Training', difficulty: 'Elite', image: '/assets/images/blackbeard.jpg' },
            { id: 'p-t-barnum', name: 'P.T. Barnum', category: 'history', description: 'Spectacular Entertainment & Master Promotion Training', difficulty: 'Advanced', image: '/assets/images/p-t-barnum.jpg' }
        ],
        // NEW! Japan Trainers Group 1
        japanOne: [
            { id: 'tea-master-sen-no-rikyu', name: 'Tea Master Sen no Rikyu', category: 'japan', description: 'Mindful Movement & Balance Specialist', difficulty: 'Advanced', image: '/assets/images/tea-master.jpg' },
            { id: 'kabuki-actor', name: 'Kabuki Master', category: 'japan', description: 'Theatrical Athletics & Expression', difficulty: 'Intermediate', image: '/assets/images/kabuki-actor.jpg' },
            { id: 'takeda-shingen', name: 'Takeda Shingen', category: 'japan', description: 'Cavalry Leadership & Strategic Conditioning', difficulty: 'Elite', image: '/assets/images/takeda-shingen.jpg' },
            { id: 'hattori-hanzo', name: 'Hattori Hanzo', category: 'japan', description: 'Stealth Conditioning & Shadow Training', difficulty: 'Elite', image: '/assets/images/hattori-hanzo.jpg' },
            { id: 'oda-nobunaga', name: 'Oda Nobunaga', category: 'japan', description: 'Revolutionary Warfare & Modernization', difficulty: 'Elite', image: '/assets/images/oda-nobunaga.jpg' },
            { id: 'tokugawa-ieyasu', name: 'Tokugawa Ieyasu', category: 'japan', description: 'Strategic Patience & Foundation Building', difficulty: 'Advanced', image: '/assets/images/tokugawa-ieyasu.jpg' }
        ],
        // NEW! Japan Trainers Group 2
        japanTwo: [
            { id: 'zen-monk-master', name: 'Zen Monk Master', category: 'japan', description: 'Enlightened Movement & Spiritual Conditioning', difficulty: 'Advanced', image: '/assets/images/zen-monk.jpg' },
            { id: 'fuma-kotaro', name: 'Fuma Kotaro', category: 'japan', description: 'Giant Ninja Combat & Guerrilla Leadership', difficulty: 'Elite', image: '/assets/images/fuma-kotaro.jpg' },
            { id: 'sumo-grand-champion', name: 'Sumo Grand Champion', category: 'japan', description: 'Sacred Strength & Immovable Power', difficulty: 'Elite', image: '/assets/images/sumo-champion.jpg' },
            { id: 'yamabushi-mountain-ascetic', name: 'Yamabushi Mountain Ascetic', category: 'japan', description: 'Elemental Training & Supernatural Endurance', difficulty: 'Elite', image: '/assets/images/yamabushi.jpg' },
            { id: 'prince-shotoku', name: 'Prince Shotoku', category: 'japan', description: 'Constitutional Wisdom & Balanced Development', difficulty: 'Advanced', image: '/assets/images/prince-shotoku.jpg' },
            { id: 'tengu-master', name: 'Tengu Master', category: 'japan', description: 'Supernatural Swordsmanship & Mountain Mastery', difficulty: 'Elite', image: '/assets/images/tengu-master.jpg' }
        ],
        // NEW! Japan Trainers Group 3
        japanThree: [
            { id: 'sohei-warrior-monk', name: 'Sohei Warrior Monk', category: 'japan', description: 'Sacred Combat & Temple Defense', difficulty: 'Advanced', image: '/assets/images/sohei-monk.jpg' },
            { id: 'date-masamune', name: 'Date Masamune', category: 'japan', description: 'Adaptive Combat & Cultural Innovation', difficulty: 'Elite', image: '/assets/images/date-masamune.jpg' },
            { id: 'uesugi-kenshin', name: 'Uesugi Kenshin', category: 'japan', description: 'Divine Warfare & Undefeated Spirit', difficulty: 'Elite', image: '/assets/images/uesugi-kenshin.jpg' },
            { id: 'emperor-meiji', name: 'Emperor Meiji', category: 'japan', description: 'Modernization Leadership & Progressive Training', difficulty: 'Advanced', image: '/assets/images/emperor-meiji.jpg' },
            { id: 'onmyoji-mystic', name: 'Onmyoji Mystic', category: 'japan', description: 'Elemental Balance & Court Mysticism', difficulty: 'Advanced', image: '/assets/images/onmyoji-mystic.jpg' },
            { id: 'noh-master', name: 'Noh Master', category: 'japan', description: 'Supernatural Performance & Timeless Artistry', difficulty: 'Elite', image: '/assets/images/noh-master.jpg' }
        ],
// NEW! Japan Trainers Group 4
        japanFour: [
            { id: 'jiraiya', name: 'Jiraiya', category: 'japan', description: 'Toad Magic & Legendary Ninja Arts', difficulty: 'Elite', image: '/assets/images/jiraiya.jpg' },
            { id: 'yamabushi-mountain-ascetic-alt', name: 'Mountain Peak Yamabushi', category: 'japan', description: 'Peak Conquest & Weather Mastery', difficulty: 'Elite', image: '/assets/images/yamabushi-alt.jpg' },
            { id: 'minamoto-no-yoritomo', name: 'Minamoto no Yoritomo', category: 'japan', description: 'Military Government & Institutional Leadership', difficulty: 'Elite', image: '/assets/images/minamoto-yoritomo.jpg' },
            { id: 'honda-tadakatsu', name: 'Honda Tadakatsu', category: 'japan', description: 'Indestructible Combat & Perfect Defense', difficulty: 'Elite', image: '/assets/images/honda-tadakatsu.jpg' },
            { id: 'sarutobi-sasuke', name: 'Sarutobi Sasuke', category: 'japan', description: 'Acrobatic Ninjutsu & Youth Energy', difficulty: 'Intermediate', image: '/assets/images/sarutobi-sasuke.jpg' },
            { id: 'ikebana-master', name: 'Ikebana Master', category: 'japan', description: 'Natural Harmony & Aesthetic Precision', difficulty: 'Advanced', image: '/assets/images/ikebana-master.jpg' }
        ],
        // NEW! Japan Trainers Group 5 (Final Masters)
        japanFive: [
            { id: 'kendo-master', name: 'Kendo Master', category: 'japan', description: 'Modern Swordsmanship & Bamboo Spirit', difficulty: 'Advanced', image: '/assets/images/kendo-master.jpg' },
            { id: 'kyudo-archer', name: 'Kyudo Master', category: 'japan', description: 'Zen Archery & Spiritual Precision', difficulty: 'Advanced', image: '/assets/images/kyudo-archer.jpg' },
            { id: 'miyamoto-musashi', name: 'Miyamoto Musashi', category: 'japan', description: 'Two-Sword Style & Strategic Mastery', difficulty: 'Elite', image: '/assets/images/miyamoto-musashi.jpg' },
            { id: 'minamoto-no-yoshitsune', name: 'Minamoto no Yoshitsune', category: 'japan', description: 'Lightning Tactics & Tragic Heroism', difficulty: 'Elite', image: '/assets/images/minamoto-yoshitsune.jpg' },
            { id: 'geisha-master', name: 'Geisha Master', category: 'japan', description: 'Cultural Arts & Refined Movement', difficulty: 'Advanced', image: '/assets/images/geisha-master.jpg' },
            { id: 'saito-hajime', name: 'Saito Hajime', category: 'japan', description: 'Left-Handed Swordsmanship & Shinsengumi Discipline', difficulty: 'Elite', image: '/assets/images/saito-hajime.jpg' }
        ],
        // NEW! Knights Trainers Group 1
        knightsOne: [
            { id: 'sir-william-marshal-1st-earl-of-pembroke', name: 'Sir William Marshal', category: 'knights', description: 'Tournament Champion & Royal Protector', difficulty: 'Elite', image: '/assets/images/Sir-William-Marshal-1st-Earl-of-Pembroke.jpg' },
            { id: 'sir-lancelot-du-lac', name: 'Sir Lancelot du Lac', category: 'knights', description: 'Sword Mastery & Courtly Excellence', difficulty: 'Elite', image: '/assets/images/Sir-Lancelot-du-Lac.jpg' },
            { id: 'sir-gawain-of-orkney', name: 'Sir Gawain of Orkney', category: 'knights', description: 'Solar-Powered Combat & Northern Warfare', difficulty: 'Elite', image: '/assets/images/Sir-Gawain-of-Orkney.jpg' },
            { id: 'sir-galahad-the-pure', name: 'Sir Galahad the Pure', category: 'knights', description: 'Sacred Combat & Spiritual Perfection', difficulty: 'Advanced', image: '/assets/images/Sir-Galahad-the-Pure.jpg' },
            { id: 'sir-gareth-of-orkney', name: 'Sir Gareth of Orkney', category: 'knights', description: 'Youthful Excellence & Chivalric Training', difficulty: 'Intermediate', image: '/assets/images/Sir-Gareth-of-Orkney.jpg' },
            { id: 'sir-percival-the-welsh', name: 'Sir Percival the Welsh', category: 'knights', description: 'Celtic Warfare & Spiritual Questing', difficulty: 'Advanced', image: '/assets/images/Sir-Percival-the-Welsh.jpg' }
        ],
        // NEW! Knights Trainers Group 2
        knightsTwo: [
            { id: 'sir-tristan-of-lyonesse', name: 'Sir Tristan of Lyonesse', category: 'knights', description: 'Artistic Combat & Musical Warfare', difficulty: 'Advanced', image: '/assets/images/Sir-Tristan-of-Lyonesse.jpg' },
            { id: 'sir-lamorak-de-galis', name: 'Sir Lamorak de Galis', category: 'knights', description: 'Maximum Strength & Heavy Combat', difficulty: 'Elite', image: '/assets/images/Sir-Lamorak-de-Galis.jpg' },
            { id: 'sir-garlon-the-invisible-knight', name: 'Sir Garlon the Invisible', category: 'knights', description: 'Stealth Combat & Psychological Warfare', difficulty: 'Elite', image: '/assets/images/Sir-Garlon-the-Invisible-Knight.jpg' },
            { id: 'sir-balin-le-savage', name: 'Sir Balin le Savage', category: 'knights', description: 'Dual Weapon Mastery & Aggressive Combat', difficulty: 'Elite', image: '/assets/images/Sir-Balin-le-Savage.jpg' },
            { id: 'sir-bors-de-ganis', name: 'Sir Bors de Ganis', category: 'knights', description: 'Sacred Combat & Divine Endurance', difficulty: 'Advanced', image: '/assets/images/Sir-Bors-de-Ganis.jpg' },
            { id: 'sir-bedivere-the-bold', name: 'Sir Bedivere the Bold', category: 'knights', description: 'Adaptive Combat & Loyal Service', difficulty: 'Advanced', image: '/assets/images/Sir-Bedivere-the-Bold.jpg' }
        ],
        // NEW! Knights Trainers Group 3
        knightsThree: [
            { id: 'sir-kay-the-seneschal', name: 'Sir Kay the Seneschal', category: 'knights', description: 'Administrative Combat & Royal Stewardship', difficulty: 'Advanced', image: '/assets/images/Sir-Kay-the-Seneschal.jpg' },
            { id: 'sir-pelleas-the-gentle', name: 'Sir Pelleas the Gentle', category: 'knights', description: 'Chivalric Excellence & Noble Refinement', difficulty: 'Advanced', image: '/assets/images/Sir-Pelleas-the-Gentle.jpg' },
            { id: 'sir-marrok-the-werewolf-knight', name: 'Sir Marrok the Werewolf', category: 'knights', description: 'Transformation Combat & Lupine Warfare', difficulty: 'Elite', image: '/assets/images/Sir-Marrok-the-Werewolf-Knight.jpg' },
            { id: 'sir-brunor-le-noir-the-black-knight', name: 'Sir Brunor le Noir', category: 'knights', description: 'Dark Presence & Anonymous Warfare', difficulty: 'Elite', image: '/assets/images/Sir-Brunor-le-Noir-The-Black-Knight.jpg' },
            { id: 'sir-dinadan-the-humorous', name: 'Sir Dinadan the Humorous', category: 'knights', description: 'Joyful Combat & Morale Warfare', difficulty: 'Intermediate', image: '/assets/images/Sir-Dinadan-the-Humorous.jpg' },
            { id: 'sir-pellimore-the-questing-beast-hunter', name: 'Sir Pellimore', category: 'knights', description: 'Beast Hunting & Obsessive Pursuit', difficulty: 'Elite', image: '/assets/images/Sir-Pellimore-the-Questing-Beast-Hunter.jpg' }
        ],
// NEW! Knights Trainers Group 4
        knightsFour: [
            { id: 'sir-tor-the-bastard', name: 'Sir Tor the Bastard', category: 'knights', description: 'Merit-Based Combat & Self-Proving', difficulty: 'Intermediate', image: '/assets/images/Sir-Tor-the-Bastard.jpg' },
            { id: 'sir-agravaine-the-proud', name: 'Sir Agravaine the Proud', category: 'knights', description: 'Superior Combat & Prideful Dominance', difficulty: 'Elite', image: '/assets/images/Sir-Agravaine-the-Proud.jpg' },
            { id: 'sir-safir-the-saracen', name: 'Sir Safir the Saracen', category: 'knights', description: 'Eastern Combat & Cultural Fusion', difficulty: 'Advanced', image: '/assets/images/Sir-Safir-the-Saracen.jpg' },
            { id: 'sir-segwarides-the-jealous', name: 'Sir Segwarides the Jealous', category: 'knights', description: 'Paranoid Combat & Suspicious Warfare', difficulty: 'Advanced', image: '/assets/images/Sir-Segwarides-the-Jealous.jpg' },
            { id: 'sir-dodinas-le-savage', name: 'Sir Dodinas le Savage', category: 'knights', description: 'Wilderness Combat & Primitive Warfare', difficulty: 'Elite', image: '/assets/images/Sir-Dodinas-le-Savage.jpg' },
            { id: 'sir-brandiles-the-bold', name: 'Sir Brandiles the Bold', category: 'knights', description: 'Courage Combat & Bold Warfare', difficulty: 'Elite', image: '/assets/images/Sir-Brandiles-the-Bold.jpg' }
        ],
        // NEW! Knights Trainers Group 5 (Final Regional & Specialized)
        knightsFive: [
            { id: 'sir-pelleas-the-younger', name: 'Sir Pelleas the Younger', category: 'knights', description: 'Legacy Combat & Youthful Excellence', difficulty: 'Intermediate', image: '/assets/images/Sir-Pelleas-the-Younger.jpg' },
            { id: 'sir-cador-of-cornwall', name: 'Sir Cador of Cornwall', category: 'knights', description: 'Regional Leadership & Coastal Defense', difficulty: 'Advanced', image: '/assets/images/Sir-Cador-of-Cornwall.jpg' },
            { id: 'sir-constantine-of-britain', name: 'Sir Constantine of Britain', category: 'knights', description: 'Tribal Warfare & Ancient Heritage', difficulty: 'Advanced', image: '/assets/images/Sir-Constantine-of-Britain.jpg' },
            { id: 'sir-lucan-the-butler', name: 'Sir Lucan the Butler', category: 'knights', description: 'Service Combat & Administrative Warfare', difficulty: 'Advanced', image: '/assets/images/Sir-Lucan-the-Butler.jpg' },
            { id: 'sir-palamedes-the-saracen', name: 'Sir Palamedes the Saracen', category: 'knights', description: 'Eastern Chivalry & Cultural Bridge', difficulty: 'Elite', image: '/assets/images/Sir-Palamedes-the-Saracen.jpg' },
            { id: 'sir-gaheris-of-orkney', name: 'Sir Gaheris of Orkney', category: 'knights', description: 'Stealth Combat & Intelligence Warfare', difficulty: 'Advanced', image: '/assets/images/Sir-Gaheris-of-Orkney.jpg' }
        ],
        // NEW! Native American Trainers Group 1
        nativeOne: [
            { id: 'crazy-horse', name: 'Crazy Horse', category: 'native-american', description: 'Vision Quest & Lightning Warfare', difficulty: 'Elite', image: '/assets/images/Crazy-Horse.jpg' },
            { id: 'sitting-bull', name: 'Sitting Bull', category: 'native-american', description: 'Medicine Power & Resistance Training', difficulty: 'Elite', image: '/assets/images/Sitting-Bull.jpg' },
            { id: 'red-cloud', name: 'Red Cloud', category: 'native-american', description: 'Strategic Victory & Honor Warfare', difficulty: 'Elite', image: '/assets/images/Red-Cloud.jpg' },
            { id: 'black-kettle', name: 'Black Kettle', category: 'native-american', description: 'Peaceful Strength & Dual Path Training', difficulty: 'Advanced', image: '/assets/images/Black-Kettle.jpg' },
            { id: 'roman-nose', name: 'Roman Nose', category: 'native-american', description: 'Sacred Protection & Fearless Combat', difficulty: 'Elite', image: '/assets/images/Roman-Nose.jpg' },
            { id: 'dull-knife', name: 'Dull Knife', category: 'native-american', description: 'Northern Resilience & Cultural Preservation', difficulty: 'Advanced', image: '/assets/images/Dull-Knife.jpg' }
        ],
        // NEW! Native American Trainers Group 2
        nativeTwo: [
            { id: 'quanah-parker', name: 'Quanah Parker', category: 'native-american', description: 'Mixed Heritage & Adaptive Leadership', difficulty: 'Elite', image: '/assets/images/Quanah-Parker.jpg' },
            { id: 'ten-bears', name: 'Ten Bears', category: 'native-american', description: 'Elder Wisdom & Sacred Buffalo Power', difficulty: 'Advanced', image: '/assets/images/Ten-Bears.jpg' },
            { id: 'geronimo', name: 'Geronimo', category: 'native-american', description: 'Desert Lightning & Medicine Power', difficulty: 'Elite', image: '/assets/images/Geronimo.jpg' },
            { id: 'cochise', name: 'Cochise', category: 'native-american', description: 'Mountain Fortress & Noble Leadership', difficulty: 'Elite', image: '/assets/images/Cochise.jpg' },
            { id: 'mangas-coloradas', name: 'Mangas Coloradas', category: 'native-american', description: 'Giant Strength & Tribal Unity', difficulty: 'Elite', image: '/assets/images/Mangas-Coloradas.jpg' },
            { id: 'victorio', name: 'Victorio', category: 'native-american', description: 'Mountain Warfare & Guerrilla Tactics', difficulty: 'Elite', image: '/assets/images/Victorio.jpg' }
        ],
        // NEW! Native American Trainers Group 3
        nativeThree: [
            { id: 'tecumseh', name: 'Tecumseh', category: 'native-american', description: 'Pan-Indian Unity & Diplomatic Warfare', difficulty: 'Elite', image: '/assets/images/Tecumseh.jpg' },
            { id: 'pontiac', name: 'Pontiac', category: 'native-american', description: 'Siege Warfare & Strategic Coordination', difficulty: 'Elite', image: '/assets/images/Pontiac.jpg' },
            { id: 'king-philip-metacomet', name: 'King Philip Metacomet', category: 'native-american', description: 'Total War & Desperate Resistance', difficulty: 'Elite', image: '/assets/images/King-Philip-Metacomet.jpg' },
            { id: 'blue-jacket', name: 'Blue Jacket', category: 'native-american', description: 'Tactical Innovation & Alliance Warfare', difficulty: 'Elite', image: '/assets/images/Blue-Jacket.jpg' },
            { id: 'cornstalk', name: 'Cornstalk', category: 'native-american', description: 'Diplomatic Strength & Noble Warfare', difficulty: 'Advanced', image: '/assets/images/Cornstalk.jpg' },
            { id: 'black-hawk', name: 'Black Hawk', category: 'native-american', description: 'Homeland Defense & Proud Resistance', difficulty: 'Elite', image: '/assets/images/Black-Hawk.jpg' }
        ],
        // NEW! Native American Trainers Group 4
        nativeFour: [
            { id: 'chief-joseph', name: 'Chief Joseph', category: 'native-american', description: 'Strategic Retreat & Noble Leadership', difficulty: 'Elite', image: '/assets/images/Chief-Joseph.jpg' },
            { id: 'looking-glass', name: 'Looking Glass', category: 'native-american', description: 'Tactical Genius & Mountain Warfare', difficulty: 'Elite', image: '/assets/images/Looking-Glass.jpg' },
            { id: 'kamiakin', name: 'Kamiakin', category: 'native-american', description: 'Diplomatic Warfare & Regional Unity', difficulty: 'Advanced', image: '/assets/images/Kamiakin.jpg' },
            { id: 'leschi', name: 'Leschi', category: 'native-american', description: 'Coastal Defense & Sacrificial Leadership', difficulty: 'Advanced', image: '/assets/images/Leschi.jpg' },
            { id: 'little-turtle', name: 'Little Turtle', category: 'native-american', description: 'Strategic Mastery & Tactical Brilliance', difficulty: 'Elite', image: '/assets/images/Little-Turtle.jpg' },
            { id: 'osceola', name: 'Osceola', category: 'native-american', description: 'Swamp Warfare & Unconquered Spirit', difficulty: 'Elite', image: '/assets/images/Osceola.jpg' }
        ],
        // NEW! Native American Trainers Group 5 (Final Mixed Nations)
        nativeFive: [
            { id: 'pushmataha', name: 'Pushmataha', category: 'native-american', description: 'Diplomatic Warfare & Southeastern Wisdom', difficulty: 'Advanced', image: '/assets/images/Pushmataha.jpg' },
            { id: 'sequoyah', name: 'Sequoyah', category: 'native-american', description: 'Intellectual Warfare & Cultural Innovation', difficulty: 'Advanced', image: '/assets/images/Sequoyah.jpg' },
            { id: 'gall', name: 'Gall', category: 'native-american', description: 'Battle Fury & Unstoppable Aggression', difficulty: 'Elite', image: '/assets/images/Gall.jpg' },
            { id: 'american-horse', name: 'American Horse', category: 'native-american', description: 'Peace Transition & Adaptive Leadership', difficulty: 'Advanced', image: '/assets/images/American-Horse.jpg' },
            { id: 'lozen', name: 'Lozen', category: 'native-american', description: 'Female Warrior Power & Spiritual Combat', difficulty: 'Elite', image: '/assets/images/Lozen.jpg' },
            { id: 'nana', name: 'Nana', category: 'native-american', description: 'Elder Endurance & Indomitable Spirit', difficulty: 'Elite', image: '/assets/images/Nana.jpg' }
        ]
    };

    useEffect(() => {
        analyzeUserProgress();
        generateSuggestions();
    }, []);

    // Analyze user's workout history for muscle group balance
    const analyzeUserProgress = () => {
        const savedWorkouts = JSON.parse(localStorage.getItem('workoutHistory') || '[]');
        const muscleGroupProgress = {};

        // Use existing muscle group analysis from ProgressGraphs
        savedWorkouts.forEach(workout => {
            if (workout.exercises && workout.exercises.length > 0) {
                workout.exercises.forEach(exercise => {
                    const muscleGroup = getMuscleGroupFromExercise(exercise);
                    const reps = workout.repCount || 10;
                    muscleGroupProgress[muscleGroup] = (muscleGroupProgress[muscleGroup] || 0) + reps;
                });
            }
        });

        setUserStats({
            totalWorkouts: savedWorkouts.length,
            muscleGroupBalance: muscleGroupProgress,
            recentWorkouts: savedWorkouts.slice(-5) // Last 5 workouts
        });
    };

    // Helper function from ProgressGraphs
    const getMuscleGroupFromExercise = (exercise) => {
        // Handle both string exercises and object exercises
        const exerciseName = typeof exercise === 'string' ? exercise : exercise.name;

        // Safety check
        if (!exerciseName || typeof exerciseName !== 'string') {
            return 'Other';
        }

        // If it's an object with muscleGroup property, use that directly
        if (typeof exercise === 'object' && exercise.muscleGroup) {
            return exercise.muscleGroup;
        }

        const exerciseNameLowerCase = exerciseName.toLowerCase();

        if (exerciseNameLowerCase.includes('push') || exerciseNameLowerCase.includes('chest') ||
            exerciseNameLowerCase.includes('bench') || exerciseNameLowerCase.includes('fly')) {
            return 'Chest';
        }

        if (exerciseNameLowerCase.includes('pull') || exerciseNameLowerCase.includes('row') ||
            exerciseNameLowerCase.includes('chin') || exerciseNameLowerCase.includes('lat') ||
            exerciseNameLowerCase.includes('deadlift')) {
            return 'Back';
        }

        if (exerciseNameLowerCase.includes('squat') || exerciseNameLowerCase.includes('lunge') ||
            exerciseNameLowerCase.includes('leg') || exerciseNameLowerCase.includes('calf')) {
            return 'Legs';
        }

        if (exerciseNameLowerCase.includes('curl') || exerciseNameLowerCase.includes('tricep') ||
            exerciseNameLowerCase.includes('bicep') || exerciseNameLowerCase.includes('dip')) {
            return 'Arms';
        }

        if (exerciseNameLowerCase.includes('shoulder') || exerciseNameLowerCase.includes('raise') ||
            exerciseNameLowerCase.includes('shrug')) {
            return 'Shoulders';
        }

        if (exerciseNameLowerCase.includes('crunch') || exerciseNameLowerCase.includes('plank') ||
            exerciseNameLowerCase.includes('twist') || exerciseNameLowerCase.includes('ab') ||
            exerciseNameLowerCase.includes('core')) {
            return 'Core';
        }

        return 'Other';
    };

    // Get weakest muscle groups for display
    const getWeakestMuscleGroups = () => {
        if (Object.keys(userStats.muscleGroupBalance).length === 0) {
            return ['No workout history yet'];
        }

        const sorted = Object.entries(userStats.muscleGroupBalance)
            .sort(([,a], [,b]) => a - b)
            .slice(0, 3)
            .map(([muscle]) => muscle);

        return sorted.length > 0 ? sorted : ['All muscle groups balanced!'];
    };
// Generate intelligent trainer suggestions - NOW WITH 150+ TRAINERS!
    const generateSuggestions = () => {
        setLoading(true);

        // Get all trainers in flat array - ULTIMATE EXPANSION!
        const allTrainersList = [
            ...allTrainers.bodyweight,
            ...allTrainers.advanced,
            ...allTrainers.strength,
            ...allTrainers.everything,
            ...allTrainers.historyOne,
            ...allTrainers.historyTwo,
            ...allTrainers.historyThree,
            ...allTrainers.historyFour,
            ...allTrainers.historyFive,
            ...allTrainers.japanOne,
            ...allTrainers.japanTwo,
            ...allTrainers.japanThree,
            ...allTrainers.japanFour,
            ...allTrainers.japanFive,
            ...allTrainers.knightsOne,
            ...allTrainers.knightsTwo,
            ...allTrainers.knightsThree,
            ...allTrainers.knightsFour,
            ...allTrainers.knightsFive,
            ...allTrainers.nativeOne,
            ...allTrainers.nativeTwo,
            ...allTrainers.nativeThree,
            ...allTrainers.nativeFour,
            ...allTrainers.nativeFive
        ];

        console.log(`🚀 Algorithm now has access to ${allTrainersList.length} trainers!`);

        // STRENGTH GOAL - Focus on maximum power and compound movements
        const strengthTrainers = [
            // Elite strength trainers
            ...allTrainers.strength.filter(t => t.difficulty === 'Elite'),
            // History conquerors (massive power)
            ...allTrainers.historyOne.filter(t => ['alexander-the-great', 'julius-caesar', 'hannibal-barca', 'attila-the-hun', 'napoleon-bonaparte'].includes(t.id)),
            // History scientists/artists (focused intensity)
            ...allTrainers.historyTwo.filter(t => ['michelangelo', 'isaac-newton', 'nikola-tesla'].includes(t.id)),
            // Revolutionary spirits (chain breakers)
            ...allTrainers.historyThree.filter(t => ['spartacus', 'boudica', 'king-leonidas', 'theodore-roosevelt'].includes(t.id)),
            // Explorers (expedition strength)
            ...allTrainers.historyFour.filter(t => ['marco-polo', 'ernest-shackleton', 'wild-bill-hickok'].includes(t.id)),
            // Literary titans (mental strength)
            ...allTrainers.historyFive.filter(t => ['edgar-allan-poe', 'oscar-wilde', 'blackbeard'].includes(t.id)),
            // Elite knights (heavy combat)
            ...allTrainers.knightsOne.filter(t => ['sir-william-marshal-1st-earl-of-pembroke', 'sir-lancelot-du-lac', 'sir-gawain-of-orkney'].includes(t.id)),
            ...allTrainers.knightsTwo.filter(t => ['sir-lamorak-de-galis', 'sir-balin-le-savage'].includes(t.id)),
            ...allTrainers.knightsThree.filter(t => ['sir-marrok-the-werewolf-knight', 'sir-pellimore-the-questing-beast-hunter'].includes(t.id)),
            ...allTrainers.knightsFour.filter(t => ['sir-agravaine-the-proud', 'sir-dodinas-le-savage', 'sir-brandiles-the-bold'].includes(t.id)),
            ...allTrainers.knightsFive.filter(t => ['sir-palamedes-the-saracen', 'sir-cador-of-cornwall'].includes(t.id)),
            // Elite advanced trainers
            ...allTrainers.advanced.filter(t => t.difficulty === 'Elite'),
            // Elite everything trainers
            ...allTrainers.everything.filter(t => t.difficulty === 'Elite'),
            // Power-focused Japan trainers
            ...allTrainers.japanOne.filter(t => ['takeda-shingen', 'oda-nobunaga', 'hattori-hanzo'].includes(t.id)),
            ...allTrainers.japanTwo.filter(t => ['fuma-kotaro', 'sumo-grand-champion', 'yamabushi-mountain-ascetic', 'tengu-master'].includes(t.id)),
            ...allTrainers.japanThree.filter(t => ['date-masamune', 'uesugi-kenshin', 'noh-master'].includes(t.id)),
            ...allTrainers.japanFour.filter(t => ['jiraiya', 'yamabushi-mountain-ascetic-alt', 'minamoto-no-yoritomo', 'honda-tadakatsu'].includes(t.id)),
            ...allTrainers.japanFive.filter(t => ['miyamoto-musashi', 'minamoto-no-yoshitsune', 'saito-hajime'].includes(t.id)),
            // Elite Native American warriors
            ...allTrainers.nativeOne.filter(t => ['crazy-horse', 'sitting-bull', 'red-cloud', 'roman-nose'].includes(t.id)),
            ...allTrainers.nativeTwo.filter(t => ['quanah-parker', 'geronimo', 'cochise', 'mangas-coloradas', 'victorio'].includes(t.id)),
            ...allTrainers.nativeThree.filter(t => ['tecumseh', 'pontiac', 'king-philip-metacomet', 'blue-jacket', 'black-hawk'].includes(t.id)),
            ...allTrainers.nativeFour.filter(t => ['chief-joseph', 'looking-glass', 'little-turtle', 'osceola'].includes(t.id)),
            ...allTrainers.nativeFive.filter(t => ['gall', 'lozen', 'nana'].includes(t.id))
        ];

        // SHREDDED GOAL - Focus on definition, medium intensity, balanced training
        const shreddedTrainers = [
            // Intermediate/Advanced bodyweight
            ...allTrainers.bodyweight.filter(t => ['Intermediate', 'Advanced'].includes(t.difficulty)),
            // Some advanced trainers
            ...allTrainers.advanced.slice(0, 3),
            // Advanced strength trainers
            ...allTrainers.strength.filter(t => t.difficulty === 'Advanced'),
            // Advanced everything trainers
            ...allTrainers.everything.filter(t => t.difficulty === 'Advanced'),
            // Artistic/balanced history trainers
            ...allTrainers.historyTwo.filter(t => ['galileo-galilei', 'albert-einstein', 'pablo-picasso'].includes(t.id)),
            // Cleopatra for strategic training
            ...allTrainers.historyOne.filter(t => t.id === 'cleopatra-vii'),
            // Revolutionary mystics
            ...allTrainers.historyThree.filter(t => ['che-guevara', 'rasputin'].includes(t.id)),
            // Exploration pioneers
            ...allTrainers.historyFour.filter(t => ['christopher-columbus', 'lewis-clark', 'amelia-earhart'].includes(t.id)),
            // Cultural artists
            ...allTrainers.historyFive.filter(t => ['wolfgang-amadeus-mozart', 'vincent-van-gogh', 'p-t-barnum'].includes(t.id)),
            // Balanced Japan trainers
            ...allTrainers.japanOne.filter(t => ['tea-master-sen-no-rikyu', 'kabuki-actor', 'tokugawa-ieyasu'].includes(t.id)),
            ...allTrainers.japanTwo.filter(t => ['zen-monk-master', 'prince-shotoku'].includes(t.id)),
            ...allTrainers.japanThree.filter(t => ['sohei-warrior-monk', 'emperor-meiji', 'onmyoji-mystic'].includes(t.id)),
            ...allTrainers.japanFour.filter(t => ['sarutobi-sasuke', 'ikebana-master'].includes(t.id)),
            ...allTrainers.japanFive.filter(t => ['kendo-master', 'kyudo-archer', 'geisha-master'].includes(t.id)),
            // Balanced knights
            ...allTrainers.knightsOne.filter(t => ['sir-galahad-the-pure', 'sir-gareth-of-orkney', 'sir-percival-the-welsh'].includes(t.id)),
            ...allTrainers.knightsTwo.filter(t => ['sir-tristan-of-lyonesse', 'sir-bors-de-ganis', 'sir-bedivere-the-bold'].includes(t.id)),
            ...allTrainers.knightsThree.filter(t => ['sir-kay-the-seneschal', 'sir-pelleas-the-gentle', 'sir-dinadan-the-humorous'].includes(t.id)),
            ...allTrainers.knightsFour.filter(t => ['sir-tor-the-bastard', 'sir-safir-the-saracen', 'sir-segwarides-the-jealous'].includes(t.id)),
            ...allTrainers.knightsFive.filter(t => ['sir-pelleas-the-younger', 'sir-lucan-the-butler', 'sir-gaheris-of-orkney'].includes(t.id)),
            // Balanced Native American trainers
            ...allTrainers.nativeOne.filter(t => ['black-kettle', 'dull-knife'].includes(t.id)),
            ...allTrainers.nativeTwo.filter(t => ['ten-bears', 'cochise'].includes(t.id)),
            ...allTrainers.nativeThree.filter(t => ['cornstalk'].includes(t.id)),
            ...allTrainers.nativeFour.filter(t => ['kamiakin', 'leschi'].includes(t.id)),
            ...allTrainers.nativeFive.filter(t => ['pushmataha', 'sequoyah', 'american-horse'].includes(t.id))
        ];

        // LOSE WEIGHT GOAL - Focus on high reps, leg-heavy, endurance, speed
        const loseWeightTrainers = [
            // All bodyweight trainers (high rep potential)
            ...allTrainers.bodyweight,
            // Some advanced for variety
            ...allTrainers.advanced.slice(0, 2),
            // Advanced everything trainers (comprehensive)
            ...allTrainers.everything.filter(t => ['Advanced', 'Elite'].includes(t.difficulty)),
            // Fast/agile history trainers
            ...allTrainers.historyOne.filter(t => ['alexander-the-great', 'attila-the-hun'].includes(t.id)),
            // Revolutionary warriors
            ...allTrainers.historyThree.filter(t => ['spartacus', 'che-guevara'].includes(t.id)),
            // Explorers with endurance
            ...allTrainers.historyFour.filter(t => ['marco-polo', 'lewis-clark', 'amelia-earhart'].includes(t.id)),
            // Movement-focused Japan trainers
            ...allTrainers.japanOne.filter(t => ['kabuki-actor', 'takeda-shingen'].includes(t.id)),
            ...allTrainers.japanTwo.filter(t => ['zen-monk-master', 'fuma-kotaro', 'yamabushi-mountain-ascetic'].includes(t.id)),
            ...allTrainers.japanThree.filter(t => ['sohei-warrior-monk', 'date-masamune'].includes(t.id)),
            ...allTrainers.japanFour.filter(t => ['jiraiya', 'sarutobi-sasuke', 'ikebana-master'].includes(t.id)),
            // Agile knights
            ...allTrainers.knightsOne.filter(t => ['sir-gareth-of-orkney', 'sir-percival-the-welsh'].includes(t.id)),
            ...allTrainers.knightsTwo.filter(t => ['sir-tristan-of-lyonesse', 'sir-garlon-the-invisible-knight'].includes(t.id)),
            ...allTrainers.knightsThree.filter(t => ['sir-pelleas-the-gentle', 'sir-marrok-the-werewolf-knight', 'sir-dinadan-the-humorous'].includes(t.id)),
            ...allTrainers.knightsFour.filter(t => ['sir-tor-the-bastard', 'sir-dodinas-le-savage'].includes(t.id)),
            ...allTrainers.knightsFive.filter(t => ['sir-pelleas-the-younger', 'sir-gaheris-of-orkney', 'sir-constantine-of-britain'].includes(t.id)),
            // Endurance-focused Native American warriors
            ...allTrainers.nativeOne.filter(t => ['crazy-horse', 'sitting-bull', 'dull-knife'].includes(t.id)),
            ...allTrainers.nativeTwo.filter(t => ['geronimo', 'victorio', 'ten-bears'].includes(t.id)),
            ...allTrainers.nativeThree.filter(t => ['tecumseh', 'pontiac', 'blue-jacket'].includes(t.id)),
            ...allTrainers.nativeFour.filter(t => ['chief-joseph', 'looking-glass', 'osceola'].includes(t.id)),
            ...allTrainers.nativeFive.filter(t => ['sequoyah', 'american-horse', 'lozen'].includes(t.id))
        ];

        // Shuffle and select 3 for each goal
        const shuffleArray = (array) => {
            const shuffled = [...array];
            for (let i = shuffled.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
            }
            return shuffled;
        };

        setSuggestions({
            strength: shuffleArray(strengthTrainers).slice(0, 3),
            shredded: shuffleArray(shreddedTrainers).slice(0, 3),
            loseWeight: shuffleArray(loseWeightTrainers).slice(0, 3)
        });

        setLoading(false);
    };

    // Handle trainer selection - UPDATED FOR ALL CATEGORIES
    const handleTrainerSelect = (trainer) => {
        try {
            soundManager.playSound('gameIntroMode2', 0.7);
        } catch (error) {
            console.warn('Sound error:', error);
        }

        // Navigate to trainer page based on category
        switch (trainer.category) {
            case 'bodyweight':
                navigate(`/trainer/${trainer.id}`);
                break;
            case 'advanced-bodyweight':
                navigate(`/advanced-trainer/${trainer.id}`);
                break;
            case 'strength':
                navigate(`/strength-trainer/${trainer.id}`);
                break;
            case 'everything':
                navigate(`/everything-trainer/${trainer.id}`);
                break;
            case 'history':
                navigate(`/history-trainer/${trainer.id}`);
                break;
            case 'japan':
                navigate(`/japan-trainer/${trainer.id}`);
                break;
            case 'knights':
                navigate(`/knight-trainer/${trainer.id}`);
                break;
            case 'native-american':
                navigate(`/native-american-trainer/${trainer.id}`);
                break;
            default:
                navigate(`/trainer/${trainer.id}`);
        }
    };

    // Handle refresh suggestions
    const handleRefreshSuggestions = () => {
        try {
            soundManager.playButtonSound();
        } catch (error) {
            console.warn('Sound error:', error);
        }
        generateSuggestions();
    };
    if (loading) {
        return (
            <div className="algorithm-train-container">
                <div className="loading-screen">
                    <h2>🤖 Analyzing Your Progress...</h2>
                    <div className="loading-spinner"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="algorithm-train-container">
            <header className="algorithm-header">
                <button className="back-button" onClick={() => navigate('/')}>
                    ← Back to Home
                </button>
                <h1>🤖 Algorithm Train</h1>
                <p>adaptive-powered trainer suggestions based on your workout history</p>

                <div className="user-stats">
                    <div className="stat-item">
                        <span className="stat-number">{userStats.totalWorkouts}</span>
                        <span className="stat-label">Total Workouts</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-number">150+</span>
                        <span className="stat-label">Available Trainers</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-text">Focus Areas: {getWeakestMuscleGroups().join(', ')}</span>
                    </div>
                </div>

                <button className="refresh-button" onClick={handleRefreshSuggestions}>
                    🔄 Refresh Suggestions
                </button>
            </header>

            <div className="goals-matrix">
                {/* STRENGTH COLUMN */}
                <div className="goal-column strength-column">
                    <div className="goal-header">
                        <h2>💪 STRENGTH</h2>
                        <p>Build maximum power with compound movements and lower reps</p>
                    </div>
                    <div className="trainers-list">
                        {suggestions.strength.map((trainer, index) => (
                            <div
                                key={trainer.id}
                                className="trainer-card strength-card"
                                onClick={() => handleTrainerSelect(trainer)}
                            >
                                <div className="trainer-image">
                                    <img
                                        src={trainer.image}
                                        alt={trainer.name}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.nextSibling.style.display = 'flex';
                                        }}
                                    />
                                    <div className="trainer-placeholder" style={{display: 'none'}}>
                                        💪
                                    </div>
                                </div>
                                <div className="trainer-info">
                                    <h3>{trainer.name}</h3>
                                    <p className="trainer-description">{trainer.description}</p>
                                    <span className="difficulty-badge strength-badge">{trainer.difficulty}</span>
                                    <span className="option-number">Option {index + 1}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* SHREDDED COLUMN */}
                <div className="goal-column shredded-column">
                    <div className="goal-header">
                        <h2>🔥 SHREDDED</h2>
                        <p>Lean muscle definition with medium difficulty and reps</p>
                    </div>
                    <div className="trainers-list">
                        {suggestions.shredded.map((trainer, index) => (
                            <div
                                key={trainer.id}
                                className="trainer-card shredded-card"
                                onClick={() => handleTrainerSelect(trainer)}
                            >
                                <div className="trainer-image">
                                    <img
                                        src={trainer.image}
                                        alt={trainer.name}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.nextSibling.style.display = 'flex';
                                        }}
                                    />
                                    <div className="trainer-placeholder" style={{display: 'none'}}>
                                        🔥
                                    </div>
                                </div>
                                <div className="trainer-info">
                                    <h3>{trainer.name}</h3>
                                    <p className="trainer-description">{trainer.description}</p>
                                    <span className="difficulty-badge shredded-badge">{trainer.difficulty}</span>
                                    <span className="option-number">Option {index + 1}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* LOSE WEIGHT COLUMN */}
                <div className="goal-column lose-weight-column">
                    <div className="goal-header">
                        <h2>⚡ LOSE WEIGHT</h2>
                        <p>High-intensity leg-focused workouts with fast movements</p>
                    </div>
                    <div className="trainers-list">
                        {suggestions.loseWeight.map((trainer, index) => (
                            <div
                                key={trainer.id}
                                className="trainer-card lose-weight-card"
                                onClick={() => handleTrainerSelect(trainer)}
                            >
                                <div className="trainer-image">
                                    <img
                                        src={trainer.image}
                                        alt={trainer.name}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.nextSibling.style.display = 'flex';
                                        }}
                                    />
                                    <div className="trainer-placeholder" style={{display: 'none'}}>
                                        ⚡
                                    </div>
                                </div>
                                <div className="trainer-info">
                                    <h3>{trainer.name}</h3>
                                    <p className="trainer-description">{trainer.description}</p>
                                    <span className="difficulty-badge lose-weight-badge">{trainer.difficulty}</span>
                                    <span className="option-number">Option {index + 1}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <footer className="algorithm-footer">
                <div className="algorithm-info">
                    <h3>🧠 How Algorithm Train Works</h3>
                    <div className="info-grid">
                        <div className="info-item">
                            <span className="info-icon">📊</span>
                            <p>Analyzes your saved workout history across 150+ legendary trainers</p>
                        </div>
                        <div className="info-item">
                            <span className="info-icon">🎯</span>
                            <p>Suggests trainers from History, Japan, Knights, Native American & more categories</p>
                        </div>
                        <div className="info-item">
                            <span className="info-icon">🔄</span>
                            <p>Updates suggestions after each workout for balanced muscle development</p>
                        </div>
                        <div className="info-item">
                            <span className="info-icon">⚖️</span>
                            <p>Goals: Strength (Elite power), Shredded (Balanced definition), Lose Weight (High endurance)</p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default AlgorithmTrain;
